module.exports = __webpack_public_path__ + "img/hello.931c4819.jpeg";